import { Card, CardBody, CardFooter, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { TotalSalesTitle } from "../../../../Constants/Constants";
import { H5, LI, P, UL } from "../../../../AbstractElements";
import ReactApexChart from "react-apexcharts";
import { TotalSale } from "../../../../Data/General/Dashboard/Default";

const TotalSales = () => {
  return (
    <Col xxl="4" md="6" className="box-col-6">
      <Card>
        <DashboardCommonHeader title={TotalSalesTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="pb-0">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <H5 className="txt-secondary f-w-600">96.675%</H5>
            <span>( Compare to last year )</span>
          </div>
          <div id="total-sale">
            <ReactApexChart options={TotalSale} series={TotalSale.series} type="bar" height={302} />
          </div>
        </CardBody>
        <CardFooter className="total-earning">
          <UL className="simple-list flex-row">
            <LI>
              <P className="mb-0">Daily Income</P>
              <span>80.80%</span>
            </LI>
            <LI>
              <P className="mb-0">Monthly Income </P>
              <span>85.34%</span>
            </LI>
          </UL>
        </CardFooter>
      </Card>
    </Col>
  );
};

export default TotalSales;
